import { render } from "./switch_checkbox.vue?vue&type=template&id=43f55e53&scoped=true"
import script from "./switch_checkbox.vue?vue&type=script&lang=js"
export * from "./switch_checkbox.vue?vue&type=script&lang=js"

import "./switch_checkbox.vue?vue&type=style&index=0&id=43f55e53&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43f55e53"]])

export default __exports__